import React from 'react';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import FormGroup from '~/components/form/FormGroup';
import { MlmOrderContext } from '~/tenants/mlm/model/MlmOrder';

export default function MlmVirtualForm(_props: TenantPerformableFormProps<MlmOrderContext>) {
  return (
    <FormGroup>
      <FormHorizontal label="# of Photos">
        <ZodFieldInput type="number" name="photos" />
      </FormHorizontal>
    </FormGroup>
  );
}
